import {BannerList} from "Components/Common/BannerList";
import {Alerts, AlertsContext} from "Components/Common/AlertsContext";
// import Sidebar from "@/layouts/authenticated-layout/components/sidebar";
import AppSidebar from "@/layouts/authenticated-layout/components/AppSidebar";
import Header from "@/layouts/authenticated-layout/components/header";
import {Container} from "react-bootstrap";
import {Utils} from "@/common/utils";
import {SchoolSelector} from "Components/Common/SchoolSelector";
import {Masquerade} from "Components/Super/Masquerade";
import React, { useEffect, useState } from "react";
import Auth from "../../common/auth/auth";
import * as Sentry from "@sentry/react";

export default function AuthenticatedLayout({children, auth}: { children?: React.ReactNode, auth: Auth}) {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

    useEffect(() => {
        const email = Utils.getCurrentUser()?.email;
        if (email) {
            Sentry.setUser({email});
        }
    }, []);

    return (
        <>
            <div className="d-flex vh-100">
                <BannerList isAuthenticated={true}/>
                {/* TODO remove Alerts and use AlertsContext instead, rename AlertsContext to Alerts */}
                <Alerts/>
                <AlertsContext/>

                {/* Sidebar */}
                <AppSidebar
                    auth={auth}
                    isCollapsed={isSidebarCollapsed}
                    onCollapsedChange={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                />

                {/* Main Content */}
                <div className="flex-grow-1 d-flex flex-column" style={{
                    marginLeft: "56px",
                    paddingTop: "56px",
                    transition: "margin-left 0.3s ease-in-out"
                }}>
                    {/* Header */}
                    <Header />

                    {/* Content */}
                    <Container fluid className="py-4 ps-4 pe-5">
                        {children}
                    </Container>
                </div>
            </div>
            {Utils.isSuperAdmin() ? (
                <div className="school-selector">
                    <SchoolSelector />
                </div>
            ) : null}
            <Masquerade/>
        </>
    );
}
